export default {
    IMAGE_TO_IMAGE: 'image-to-image',
    IMAGE_ENHANCER: 'image-upscaler',
    TEXT_TO_IMAGE: 'text-to-image',
    PHOTO_RESTORATION: 'old-photo-restoration',
    PHOTO_COLORIZE: 'photo-colorizer',
    FACE_SWAP: 'face-swap',
    CLOTHES_CHANGER: 'clothes-changer',
    IMAGE_EXTENDER: 'image-extender',
    FAKE_3D: '3d-photo-animation',
    OBJECT_ERASER: 'object-remover',
    PHOTO_REMOVE_BG: 'photo-remove-bg',
    AI_VIDEO_GENERATOR: 'ai-video-generator',
    VIDEO_REMOVE_BG: 'video-bg-remover',
    AI_AUDIO_GENERATOR: 'ai-music-generator',
    AI_VIDEO_DUB: 'video-to-ai-sfx',
    AI_TEXT_BASED_EDITING: 'ai-text-based-editing',
    IMAGE_TO_VIDEO: 'IMAGE_TO_VIDEO',
    TEXT_TO_FULL_VIDEO: 'ai-text-to-full-video',
    BLOG_URL_TO_VIDEO: 'ai-blog-url-to-video',
    PRODUCT_URL_TO_VIDEO: 'ai-product-url-to-video',
    PPT_TO_VIDEO: 'ai-ppt-to-video',
    AI_HAIRSTYLE_CHANGER: 'ai-hairstyle-changer',
    AI_PHOTO_EDITOR: 'ai-photo-editor',
    TEXT_TO_SPEECH: 'TEXT_TO_SPEECH',
    AI_VOICE_CLONING: 'AI_VOICE_CLONING',
    TEXT_TO_VIDEO: 'TEXT_TO_VIDEO',
    WATERMARK_REMOVER: 'watermark-remover',
    HEADSHOT_GENERATOR: 'headshot-generator',
    AI_COMMUNITY: 'ai-community',
    AI_VIDEO_EFFECT: 'ai-video-effect',
};
